export default __webpack_public_path__ + "static/media/sibling-rivalry@2x 4.1207cc2b.png";